import { render, staticRenderFns } from "./CreateTreatmentTypeButtons.vue?vue&type=template&id=08166b18&scoped=true"
import script from "./CreateTreatmentTypeButtons.vue?vue&type=script&lang=js"
export * from "./CreateTreatmentTypeButtons.vue?vue&type=script&lang=js"
import style0 from "./CreateTreatmentTypeButtons.vue?vue&type=style&index=0&id=08166b18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08166b18",
  null
  
)

export default component.exports